import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Grid, MenuItem, Paper } from '@mui/material';

const cargoTypes = [
  { value: 'container', label: 'Container' },
  { value: 'bulk', label: 'Bulk Cargo' },
  { value: 'vehicle', label: 'Vehicle' },
  { value: 'general', label: 'General Cargo' },
  { value: 'other', label: 'Other' },
];

const QuoteRequestForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    origin: '',
    destination: '',
    cargoType: '',
    cargoDetails: '',
    shippingDate: '',
    notes: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          subject: 'Quote Request',
          message: `Quote Request\nName: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nOrigin: ${formData.origin}\nDestination: ${formData.destination}\nCargo Type: ${formData.cargoType}\nCargo Details: ${formData.cargoDetails}\nPreferred Shipping Date: ${formData.shippingDate}\nNotes: ${formData.notes}`
        }),
      });
      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', phone: '', origin: '', destination: '', cargoType: '', cargoDetails: '', shippingDate: '', notes: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <Box id="quote" sx={{ py: 4, background: 'transparent' }}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, background: '#181a20', color: '#c9a74c', borderRadius: 4 }}>
            <Typography variant="h4" align="center" gutterBottom fontWeight={700} color="primary.main" sx={{ fontSize: '2rem' }}>
              Request a Shipping Quote
            </Typography>
            <Typography align="center" sx={{ mb: 3, fontSize: '1.15rem', color: '#c9a74c' }}>
              Fill out the form below and our team will get back to you with a custom quote for your shipment.
            </Typography>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField label="Full Name" name="name" value={formData.name} onChange={handleChange} fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Email Address" name="email" value={formData.email} onChange={handleChange} type="email" fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Phone Number" name="phone" value={formData.phone} onChange={handleChange} fullWidth InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Preferred Shipping Date" name="shippingDate" value={formData.shippingDate} onChange={handleChange} type="date" fullWidth InputLabelProps={{ shrink: true, style: { color: '#c9a74c', fontSize: '1.1rem' } }} InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Origin (Port/City/Country)" name="origin" value={formData.origin} onChange={handleChange} fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Destination (Port/City/Country)" name="destination" value={formData.destination} onChange={handleChange} fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField select label="Cargo Type" name="cargoType" value={formData.cargoType} onChange={handleChange} fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }}>
                    {cargoTypes.map(option => (
                      <MenuItem key={option.value} value={option.value} style={{ fontSize: '1.1rem', color: '#c9a74c', background: '#232a36' }}>{option.label}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField label="Cargo Details (weight, volume, etc.)" name="cargoDetails" value={formData.cargoDetails} onChange={handleChange} fullWidth required InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12}>
                  <TextField label="Additional Notes" name="notes" value={formData.notes} onChange={handleChange} fullWidth multiline rows={3} InputProps={{ style: { fontSize: '1.1rem', color: '#c9a74c' } }} InputLabelProps={{ style: { color: '#c9a74c', fontSize: '1.1rem' } }} />
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" variant="contained" color="primary" size="large" fullWidth sx={{ mt: 2, fontWeight: 700, fontSize: '1.15rem', py: 1.5, borderRadius: 2 }}>
                    Request Quote
                  </Button>
                  {status === 'success' && (
                    <Typography color="success.main" sx={{ mt: 2 }}>
                      Quote request sent successfully!
                    </Typography>
                  )}
                  {status === 'error' && (
                    <Typography color="error.main" sx={{ mt: 2 }}>
                      Failed to send quote request. Please try again later.
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuoteRequestForm; 